import {
  CARDADD_REQUEST,
  CARDADD_SUCCESS,
  CARDADD_ERROR,
  UNSUBCRIPTION_REQUEST,
  UNSUBCRIPTION_SUCCESS,
  UNSUBCRIPTION_ERROR,
  GET_PLAN_ERROR,
  GET_PLAN_REQUEST,
  GET_PLAN_SUCCESS,
} from "./actions";

const initialState = {
  request: false,
  unsubcriptionrequest: false,
  plan: null,
  error: undefined,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_PLAN_REQUEST:
      return {
        requesting: true,
        successful: false,
        plan: undefined,
        error: undefined,
      };

    case GET_PLAN_SUCCESS:
      return {
        requesting: false,
        successful: true,
        plan: action.plan,
        error: undefined,
      };

    case GET_PLAN_ERROR:
      return {
        requesting: false,
        successful: false,
        plan: undefined,
        error: action.error,
      };
    case CARDADD_REQUEST: {
      return {
        request: true,
      };
    }
    case CARDADD_SUCCESS: {
      return {
        request: false,
      };
    }
    case CARDADD_ERROR: {
      return {
        request: false,
        error: JSON.parse(action.error),
      };
    }
    case UNSUBCRIPTION_REQUEST: {
      return {
        unsubcriptionrequest: true,
      };
    }
    case UNSUBCRIPTION_SUCCESS: {
      return {
        unsubcriptionrequest: false,
      };
    }
    case UNSUBCRIPTION_ERROR: {
      return {
        unsubcriptionrequest: false,
        error: JSON.parse(action.error),
      };
    }

    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/pages/subscription/reducer.js